import React from 'react';
import { ErrorState } from './PageStates';

/**
 * What a route shows when its page throws, in place of the router's default
 * error page. Trying again reloads the page.
 */
export default function RouteError() {
  return (
    <ErrorState
      message="This page couldn't be shown. Try again, or go back."
      onRetry={() => window.location.reload()}
    />
  );
}
